import { type } from 'os';

export enum PolygonsActions {
  SET_SELECTED_SWITCH = 'SET_SELECTED_SWITCH',
  SET_NAME_AND_ID_TO_EDIT = 'SET_NAME_AND_ID_TO_EDIT',
  SET_NAME_AND_ID_TO_DELETE = 'SET_NAME_AND_ID_TO_DELETE',
  REFETCH_DATA = 'REFETCH_DATA',
  DISPLAY_OWN_POLYGONS = 'DISPLAY_OWN_POLYGONS',
  SET_IS_LOADING_POLYGONS = 'SET_IS_LOADING_POLYGONS',
  UPDATE_DRAW_STATE = 'UPDATE_DRAW_STATE',
}

type UpdateDrawStateParams = {
  type: string;
  radius: null | number;
  coords: null | google.maps.LatLng[];
  center: null | google.maps.LatLng;
  isActive: boolean;
};

type setNameAndIdToEditOrDeleteParams = {
  name: string;
  id: string;
};

export const setSelectedSwitch = (payload: string) => ({
  type: PolygonsActions.SET_SELECTED_SWITCH,
  payload,
});

export const setNameAndIdToEdit = (
  payload: setNameAndIdToEditOrDeleteParams
) => ({
  type: PolygonsActions.SET_NAME_AND_ID_TO_EDIT,
  payload,
});

export const setNameAndIdToDelete = (
  payload: setNameAndIdToEditOrDeleteParams
) => ({
  type: PolygonsActions.SET_NAME_AND_ID_TO_DELETE,
  payload,
});

export const refetchData = () => ({
  type: PolygonsActions.REFETCH_DATA,
});

export const displayOwnPolygons = (payload: boolean) => ({
  type: PolygonsActions.DISPLAY_OWN_POLYGONS,
  payload,
});

export const setIsLoadingPolygons = (payload: boolean) => ({
  type: PolygonsActions.SET_IS_LOADING_POLYGONS,
  payload,
});

export const updateDrawState = (payload: UpdateDrawStateParams) => ({
  type: PolygonsActions.UPDATE_DRAW_STATE,
  payload,
});
